import React, { Component } from 'react';
import { func, node, object, shape, string } from 'prop-types';
import { Field } from 'react-final-form';
import loadable from '@loadable/component';
import { ValidationError } from '../../components';
import classNames from 'classnames';

import css from './LocationAutocompleteInput.module.css';

// LocationAutocompleteInputImpl is a big component that includes code for both Mapbox and Google Maps
// It is loaded dynamically - i.e. it is splitted to its own code chunk.
const LocationAutocompleteInputImpl = loadable(() =>
  import(/* webpackChunkName: "LocationAutocompleteInputImpl" */ './LocationAutocompleteInputImpl')
);

class LocationAutocompleteInputComponent extends Component {
  render() {
    const {
      rootClassName,
      labelClassName,
      additionalLabel,
      hideErrorMessage,
      onChange: propsOnChange,
      ...restProps
    } = this.props;
    const { input, id, label, meta, valueFromForm, ...otherProps } = restProps;

    const value = typeof valueFromForm !== 'undefined' ? valueFromForm : input.value;

    const onChange = event => {
      propsOnChange?.(event);
      input.onChange(event);
    };

    const locationAutocompleteProps = {
      label,
      meta,
      ...otherProps,
      input: { ...input, onChange, id, value },
    };
    const labelInfo = label ? (
      <div className={classNames(css.label, labelClassName)}>
        <label htmlFor={id}>{label}</label>
        {additionalLabel}
      </div>
    ) : null;

    return (
      <div className={rootClassName}>
        {labelInfo}
        <LocationAutocompleteInputImpl {...locationAutocompleteProps} />
        {hideErrorMessage ? null : <ValidationError fieldMeta={meta} />}
      </div>
    );
  }
}

LocationAutocompleteInputComponent.defaultProps = {
  rootClassName: null,
  labelClassName: null,
  type: null,
  label: null,
  id: null,
};

LocationAutocompleteInputComponent.propTypes = {
  rootClassName: string,
  labelClassName: string,
  input: shape({
    onChange: func.isRequired,
    name: string.isRequired,
  }).isRequired,
  id: string,
  label: string,
  additionalLabel: node,
  meta: object.isRequired,
};

export default LocationAutocompleteInputImpl;

export const FieldLocationAutocompleteInput = props => {
  return <Field component={LocationAutocompleteInputComponent} {...props} />;
};
